import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Search, CrudService, MessageService, SharedDataService } from 'elbuild-ui-lib-core';
import { Country, Comune, Provincia, User, UserType } from 'toolbandi-ui-lib';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClassType } from 'class-transformer/ClassTransformer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-user-new-edit',
	templateUrl: './user-new-edit.component.html',
	styleUrls: ['./user-new-edit.component.scss']
})
export class UserNewEditComponent implements OnInit, OnDestroy {


	loading: boolean = false;
	@Input() user: User;


	showroles: boolean = true;

	tab: string;
	title: string;

	editable: boolean = true;

	search: {
		nazione: Search,
		comune: Search,
		provincia: Search
	};
	selected: {
		nazione: Country,
		comune: Comune,
		provincia: Provincia,
	};
	nazioneClass: ClassType<Country> = Country;

	password: {
		password: string,
		repeatpassword: string
	};

	@Input()
	companyid: number;

	error: boolean;


	statuses = ['active', 'idle', 'locked'];
	isAdmin: boolean;

	constructor(private crudService: CrudService<User>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,
		private countryService: CrudService<Country>,
		private provinceService: CrudService<Provincia>,
		private comuneService: CrudService<Comune>,
		private activeModal: NgbActiveModal,
		private router: Router
	) {

		this.selected = {
			nazione: new Country(),
			comune: undefined,
			provincia: undefined,
		};
		this.search = {
			nazione: new Search('country'),
			comune: new Search('comuni'),
			provincia: new Search('province')

		};
		this.password = { password: '', repeatpassword: '' };
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			if (id) {
				this.load(id);
			} else {
				this.title = 'user-create';
				this.user = new User();
				if (this.companyid) {
					this.user.utype = UserType.company;
					this.user.companyid = this.companyid;
				} else {
					this.user.utype = UserType.admin;
				}
			}

		});


	}

	ngOnDestroy() {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.crudService.getEntity(User, 'user', id).subscribe(user => {
			this.user = user;
			this.loading = false;
			if (this.user) {
				this.error = false;
				this.title = 'user-edit';
				this.initItem();
			} else {
				this.error = true;
			}
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.user'));
			this.user = undefined;
			this.loading = false;
			this.error = true;
		});
	}


	findCountry(name: any): void {
		if (name) {
			const countrySearch = new Search('country');
			countrySearch.addLikeFilter('name', name);
			this.countryService
				.searchEntities(Country, 'country', countrySearch, countrySearch.page)
				.subscribe((c: Country[]) => {
					this.selected.nazione = c[0];
				});
		}
	}

	findProvince(descrizione: any): void {
		if (descrizione) {
			const provinceSearch = new Search('province');
			provinceSearch.addLikeFilter('descrizione', descrizione);
			this.provinceService
				.searchEntities(Provincia, 'province', provinceSearch, provinceSearch.page)
				.subscribe((p: Provincia[]) => {
					this.selected.provincia = p[0];
				});
		}
	}

	findComune(descrizione: any): void {
		if (descrizione) {
			const comuneSearch = new Search('comuni');
			comuneSearch.addLikeFilter('descrizione', descrizione);
			this.comuneService
				.searchEntities(Comune, 'comuni', comuneSearch, comuneSearch.page)
				.subscribe((c: Comune[]) => {
					this.selected.comune = c[0];
				});
		}
	}

	updateSelects() {

		if (this.selected.provincia) {
			this.search.comune.addSimpleFilter('provincia', this.selected.provincia.descrizione);
		} else {
			this.selected.comune = undefined;
		}
		if (this.selected.nazione === undefined || this.selected.nazione.name !== 'Italia') {
			this.selected.comune = undefined;
			this.selected.provincia = undefined;
		}
	}

	setSelectFields() {
		if (this.selected.nazione && this.selected.nazione.id) {
			this.user.country = this.selected.nazione.name;
			this.user.iso = this.selected.nazione.sigla;
		}
		if (this.selected.comune && this.selected.comune.id) {
			this.user.comune = this.selected.comune.descrizione;
		}
		if (this.selected.provincia && this.selected.provincia.id) {
			this.user.province = this.selected.provincia.descrizione;
		}
	}

	initItem() {
		this.findCountry(this.user.country);
		this.findProvince(this.user.province);
		this.findComune(this.user.comune);
	}


	submit() {
		if (this.password && this.password.password && this.password.password !== '') {
			if (this.password.password !== this.password.repeatpassword) {
				this.messageService.sendError(this.translateService.instant('labels.password-mismatch'), this.translateService.instant('labels.create-user'));
				return;
			} else {
				this.user.password = this.password.password;
			}
		} else {
			this.user.password = undefined;
		}
		this.setSelectFields();
		if (!this.user.id) {
			this.crudService.createEntity(User, 'user', this.user).subscribe(response => {
				this.user = response;
				const messages = this.translateService.instant(['labels.user-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.user-save-success'], messages['labels.success']);
				this.activeModal.close(this.user);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {

			this.crudService.saveEntity(User, 'user', this.user).subscribe(response => {
				this.user = response;
				this.initItem();
				const messages = this.translateService.instant(['labels.user-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.user-save-success'], messages['labels.success']);
				this.activeModal.close(this.user);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}
	}

	dismiss() {
		this.activeModal.dismiss();
	}
}
